import { Integration, iOrder as iOrderType } from "/app/src/models";
import { useNumberId } from "/app/src/hooks/useNumberId";
import { iOrderService } from "/app/src/services";
import { useQuery } from "@tanstack/react-query";

import { useTranslation } from "react-i18next";
import Revisions from "./revisions";
import Lines from "./lines";
import OrderDetails from "./orderDetails";
import { useState, useEffect } from "react";
import { Alert, Spinner } from "@heroui/react";
import useSetting from "/app/src/components/settings/setting";
import { convertStringToBoolean } from "/app/src/helpers";

/**
 * Displays the order details of an order created through the Order Builder App
 */
export default function OrderBuildOrder({
  integration,
}: {
  integration: Integration;
}) {
  const { orderId } = useNumberId();
  const { t } = useTranslation();
  const [refetchInterval, setRefetchInterval] = useState<number | false>(false);
  const { data: iOrder } = useQuery({
    queryKey: ["order", orderId],
    queryFn: () => {
      return iOrderService.getSingle(orderId);
    },
    initialData: { order: { loadedData: {}, lines: [] } },
    select: (data: { order: iOrderType }) => {
      return data.order;
    },
    refetchInterval,
  });
  useEffect(() => {
    if (iOrder?.orderStatus === "Ready to be Sent to Power Pick") {
      setRefetchInterval(2000);
    } else {
      setRefetchInterval(false);
    }
  }, [iOrder]);

  const { settingValue: disableRevisions } = useSetting({
    integrationId: integration?.id,
    type: "disableRevisions",
  });

  return (
    <>
      {iOrder?.lastErrorMessage && iOrder?.orderStatus === "Error" && (
        <Alert
          color="danger"
          className="mb-[20px]"
          title={iOrder?.lastErrorMessage}
        />
      )}
      <OrderDetails iOrder={iOrder} />
      <Lines order={iOrder} />
      {!convertStringToBoolean(disableRevisions) && (
        <>
          <h2 className="pt-[20px]">{t("translation:revisions")}</h2>
          <Revisions order={iOrder} />
        </>
      )}
      {iOrder?.orderStatus === "Ready to be Sent to Power Pick" && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <Spinner />
        </div>
      )}
    </>
  );
}
